const generateOffsetToXPositionInWeeks = () => {
  const xPositionToWeeks = {
    154: 0, // Adjusted position 154 for 0 weeks
  };
  for (let week = 1; week <= 37; week++) {
    // Calculate X position dynamically for each week
    xPositionToWeeks[22 * week] = week * 604800;
  }
  return xPositionToWeeks;
};

const XPositionToWeeksOffset = generateOffsetToXPositionInWeeks();

export default XPositionToWeeksOffset;


// WEBPACK FOOTER //
// ./src/components/sitewide/XPositionToWeeksOffset.js